import {
    CollapsibleList,
    DateTimeUtils,
    OnHoverOnClick,
    Table,
} from "dyl-components";
import React from "react";
import Avatar from "react-avatar";
import { Icon } from "semantic-ui-react";
import HoverContent from "shared/hoverContent";

import { StringUtils } from "utils";

const HistoryRow = ({ historyData, destinationCategories }) => {
    const message = historyData?.message?.split(":");
    const isContact = historyData?.contact?.id;
    const getMessageName = () => {
        if (!historyData?.activity_type) return;
        if (historyData?.activity_type === "route") {
            const rawMessage = message?.[1] || "";

            const replacedMessage = rawMessage
                .split(" ")
                .map((item) => {
                    if (!item.includes("/")) return item;

                    const [parent, child] = item.split("/");

                    const category = destinationCategories?.find(
                        (c) => c.value === parent
                    );

                    const destination = category?.options?.find(
                        (d) => d.value === child
                    );

                    return category && destination
                        ? `${category.text}/${destination.text}`
                        : item;
                })
                .join(" ");
            return <React.Fragment>
                <span style={{ fontWeight: "bold" }}>{message?.[0]}:{" "}</span>{replacedMessage}
            </React.Fragment>
        }
        return (
            <>
                <span style={{ fontWeight: "bold" }}>
                    {StringUtils.capitalize(message?.[0])}:{" "}
                </span>
                {message?.[1]}

                {historyData?.note?.close_reason && (
                    <CollapsibleList
                        minimumNumberOfItemsToShow={0}
                        items={[
                            historyData.note.close_reason,
                            historyData.note.close_reason_note
                        ]}
                        action="View"
                    />
                )}
            </>
        );
    };
    const contactOrAccountData = isContact ? historyData.contact : historyData.account;
    return (
        <Table.Row>
            <Table.Cell>
                <div><b>{DateTimeUtils.formatEpoch(historyData.created, DateTimeUtils.WORD_DATE_FORMAT)}</b></div>
                <div>{DateTimeUtils.formatEpoch(historyData.created, DateTimeUtils.TIME_FORMAT)}</div>
            </Table.Cell>
            <Table.Cell>
                {StringUtils.capitalize(historyData?.activity_type?.split("_")?.join(" "))}
            </Table.Cell>
            <Table.Cell>
                {getMessageName()}
            </Table.Cell>
            <Table.Cell>
                <Avatar
                    name={contactOrAccountData?.name}
                    email={contactOrAccountData?.email?.value}
                    round
                    size='3em'
                    maxInitials={2} className={contactOrAccountData?.active === false ? 'InactiveAvtar' : ''}
                />
            </Table.Cell>
            <Table.Cell>
                {historyData?.user?.id ? (
                    <OnHoverOnClick
                        hoverContent={
                            <HoverContent
                                user={historyData.user}
                            />
                        }
                        
                        clickable={false}
                        onClick={undefined}
                        trigger={
                            <Avatar
                                name={`${historyData.user?.first_name} ${historyData.user?.last_name}`}
                                email={historyData.user?.email}
                                round
                                size='3em'
                                maxInitials={2} className={historyData.user.active === false ? 'InactiveAvtar' : ''} />
                        }
                    />
                ) : (
                    <Icon
                        className='fas fa-robot AutomationIcon'
                        circular
                        size='large'
                    />
                )}
            </Table.Cell>
        </Table.Row>
    );
};

export default HistoryRow;
